module.exports = __webpack_public_path__ + "static/media/35_B.6358ec1f.png";